export type MapLayersState = {
  assets: boolean;
  users: boolean;
  work: boolean;
  geospatialLayers: boolean;
  assetSchemas: Set<string>;
  workStatusIds: Set<string>;
  workTemplateIds: Set<string>;
  workTemplateFolderIds: Set<string>;
  kmlLayerIds: Set<string>;
  arcgisLayerIds: Set<string>;
  categoryIds: Set<string>;
  clusterDensity: string;
};

export type LayerToggleKey = 'assets' | 'users' | 'work' | 'geospatialLayers';
export type LayerFilterKey =
  | 'assetSchemas'
  | 'workStatusIds'
  | 'workTemplateIds'
  | 'workTemplateFolderIds'
  | 'kmlLayerIds'
  | 'arcgisLayerIds'
  | 'categoryIds';

export type MapLayersAction =
  | { type: 'SET_LAYER'; key: LayerToggleKey; value: boolean }
  | { type: 'SET_FILTER'; key: LayerFilterKey; value: Set<string> };

export const mapLayersReducer = (
  state: MapLayersState,
  action: MapLayersAction,
): MapLayersState => {
  switch (action.type) {
    case 'SET_LAYER':
      return { ...state, [action.key]: action.value };
    case 'SET_FILTER':
      return { ...state, [action.key]: action.value };
    default:
      return state;
  }
};
